import qs from 'qs'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function makeQueryUrl(url: string, query: any) {
  if (query) {
    removeKey(query)
  }

  const queryString = qs.stringify(query, { indices: false })

  if (!queryString) {
    return url
  }
  return url + '?' + queryString
}

function removeKey(query: any) {
  Object.keys(query).forEach((key) => {
    if (!query[key] && query[key] !== 0 && query[key] !== false) {
      delete query[key]
    }
  })
}
